import React from 'react';
import ComunicadorApp from "./ComunicadorApp";

export const ComunicadorConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/central-de-notificacoes',
            component: () => (
                <ComunicadorApp
                    gerenciador={"central-notificacoes"}
                />
            )
        }
    ]
};
